import styles from "./index.module.scss";

const CustomIFrame = ({ iframeData }) => {
  return (
    <div className={iframeData?.padding ? styles["iframe-with-padding"] : ""}>
      <iframe
        title={iframeData?.title || "Custom iframe content"}
        width={"100%"}
        src={iframeData?.src}
        height={iframeData?.height}
      ></iframe>
    </div>
  );
};

export default CustomIFrame;
